import React, { PureComponent } from 'react'
import MobileInput from '../components/MobileInput'
import LoginButton from '../components/LoginButton'
import { FetchPost } from '../Common'
import { message } from 'antd'

export default class MobileInputFrame extends PureComponent {

    state = {
        mobile: null,
        countryCode: '86',
        buttonStatus : 'disabled',
    }

    onMobileChange = mobile => {
        this.setState({ mobile: mobile })
        if (mobile.length === 11) {
            this.setState({ buttonStatus : 'nomal' })
        } else {
            this.setState({ buttonStatus : 'disabled' })
        }
    }

    onButtonClick = () => {
        this.setState({buttonStatus: 'loading'})
        this.verifyMobileLegal(this.state.mobile, this.state.countryCode)
    }
    
    jointAuthMsg(basePath) {
        let escapeReturnUrl = escape(this.props.returnUrl)
        return basePath + '?ReturnUrl=' + escapeReturnUrl + '&clientId=' + this.props.clientId
    }

    verifyMobileLegal(mobile, countryCode) {
        if (!mobile) {
            message.error('请填写手机号!')
            return
        }
        if (!countryCode) {
            message.error('请填写手机号国家编码!')
            return
        }
        FetchPost(
            window.PROPS.path.verifyMobileLegal, {
                mobile: mobile,
                countryCode: countryCode
            }, data => {
                if (data.errorCode === '0') {
                    let result = data.content.result;
                    if (result === 'ILLEGAL') {
                        message.error('手机号不合法!')
                        return
                    }
                    this.props.sendVcode(
                        mobile, 
                        countryCode, 
                        () => this.props.sendVcodeSuccess(mobile, countryCode), 
                        () => this.setState({buttonStatus: 'nomal'})
                    );
                } else {
                    this.setState({buttonStatus: 'nomal'})
                }
            }
        );
    }

    render() {
        return (
            <div style={{width: 311, userSelect: 'none'}}>
                <div className='rollbackTag' style = {{marginBottom: 24}}></div>
                <div className='majorTitle' style = {{marginBottom: 13}}>你好，欢迎登录</div>
                <div className='subTitle' style = {{marginBottom: 52}}>与你的团队和朋友在ME中进行交流与协作</div>
                <div style = {{marginBottom: 44}}>
                    <MobileInput
                        onMobileChange = {this.onMobileChange}
                        carriagReturn = {this.onButtonClick}
                        placeholder = '请输入手机号'
                    ></MobileInput>
                </div>
                <div style = {{marginBottom: 44}}>
                    <LoginButton
                        onClick = {this.onButtonClick}
                        status = {this.state.buttonStatus}
                    ></LoginButton>
                </div>
                <div className='grayTag'></div>
            </div>
        )
    }
}
